import { VIEW_MANAGEMENT } from 'store/types';

function hideHomePagePreloader() {
  return {
    type: VIEW_MANAGEMENT.HIDE_HOME_PAGE_PRELOADER,
  };
}

export default hideHomePagePreloader;
